import * as React from 'react';
import classnames from 'classnames';
import EntityField from './EntityField';
import _ from 'lodash';

import { HelpTooltip } from 'common/components/core/help';

class EntityFormField extends React.PureComponent {
    render() {
        const {
            theme,
            field,
            entity,
            isEditing,
            getMappedProps,
            onChange,
            onBlur,
            t
        } = this.props;
        const helpText = _.isFunction(field.helpText)
            ? field.helpText({
                  entity
              })
            : field.helpText;
        const EntityComponent = (
            <EntityField
                t={t}
                isEditing={isEditing}
                theme={theme}
                entity={entity}
                field={field}
                onChange={onChange}
                onBlur={onBlur}
                getMappedProps={getMappedProps}
                testId={field.testId}
            />
        );
        if (field.formComponent) {
            return EntityComponent;
        }
        const required = _.isFunction(field.required)
            ? field.required({
                  props: getMappedProps(),
                  entity
              })
            : field.required;

        return (
            <div
                className={classnames(theme.fieldGroup, {
                    [theme.halfWidth]: field.halfWidth,
                    [theme.halfWidthInput]: field.halfWidthInput
                })}
                data-test-id={field.accessor}
            >
                <span className={theme.label}>
                    {_.isFunction(field.label)
                        ? field.label({
                              t,
                              props: getMappedProps()
                          })
                        : t(field.label)}
                    {required ? '*' : null}
                    {helpText ? (
                        <HelpTooltip tooltipText={t(helpText)} />
                    ) : null}
                </span>
                {EntityComponent}
            </div>
        );
    }
}

export default EntityFormField;
